import { render, staticRenderFns } from "./CmgNutritionCalculatorMealBuilderCard.vue?vue&type=template&id=f5bc5078&scoped=true&lang=pug"
import script from "./cmg-nutrition-calculator-meal-builder-card.ts?vue&type=script&lang=ts&external"
export * from "./cmg-nutrition-calculator-meal-builder-card.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgNutritionCalculatorMealBuilderCard.vue?vue&type=style&index=0&id=f5bc5078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bc5078",
  null
  
)

export default component.exports